import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
interface RedirectImportTableRowProps {
  path: string;
  code: number;
  targetType: string;
  target?: string;
  query_string?: string;
  created?: string;
}
const ImportTableRowDisabled = ({
  path,
  code,
  targetType,
  target,
  query_string,
  created
}: RedirectImportTableRowProps) => {
  const {
    t
  } = useTranslation();
  return <Grid container spacing={3} width="100%" py={2} pl={2} pr={1} direction="row" sx={{
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "nowrap",
    color: "text.secondary",
    "&:nthOfType(even)": {
      background: "grey.50"
    }
  }} data-sentry-element="Grid" data-sentry-component="ImportTableRowDisabled" data-sentry-source-file="ImportTableRowDisabled.tsx">
      <Grid size="grow" minWidth="200px" data-sentry-element="Grid" data-sentry-source-file="ImportTableRowDisabled.tsx">
        <Typography variant="body2" fontWeight={400} color="action.active" data-sentry-element="Typography" data-sentry-source-file="ImportTableRowDisabled.tsx">
          {path}
        </Typography>
      </Grid>

      <Grid minWidth="115px" data-sentry-element="Grid" data-sentry-source-file="ImportTableRowDisabled.tsx">
        <ToggleButtonGroup color="primary" value={code} size="small" disabled data-sentry-element="ToggleButtonGroup" data-sentry-source-file="ImportTableRowDisabled.tsx">
          <ToggleButton value={302} data-sentry-element="ToggleButton" data-sentry-source-file="ImportTableRowDisabled.tsx">302</ToggleButton>
          <ToggleButton value={301} data-sentry-element="ToggleButton" data-sentry-source-file="ImportTableRowDisabled.tsx">301</ToggleButton>
        </ToggleButtonGroup>
      </Grid>

      <Grid minWidth="130px" data-sentry-element="Grid" data-sentry-source-file="ImportTableRowDisabled.tsx">
        <Typography variant="body2" fontWeight={400} color="action.active" px={1} data-sentry-element="Typography" data-sentry-source-file="ImportTableRowDisabled.tsx">
          {targetType}
        </Typography>
      </Grid>

      <Grid size="grow" minWidth="200px" data-sentry-element="Grid" data-sentry-source-file="ImportTableRowDisabled.tsx">
        <Typography variant="body2" fontWeight={400} color="action.active" px={1} data-sentry-element="Typography" data-sentry-source-file="ImportTableRowDisabled.tsx">
          {target}
        </Typography>
      </Grid>
      <Grid width="115px" data-sentry-element="Grid" data-sentry-source-file="ImportTableRowDisabled.tsx">
        <Typography variant="body2" fontWeight={400} color="action.active" textAlign="center" data-sentry-element="Typography" data-sentry-source-file="ImportTableRowDisabled.tsx">
          {created ? t("seo.importRowCreated") : t("seo.importRowPreExisting")}
        </Typography>
      </Grid>
    </Grid>;
};
export default ImportTableRowDisabled;